// Role helpers and constants
export const ROLE_LABEL = { leader: 'Leader', manager: 'Manager', team: 'Team' };

// v6 — enterprise priorities. Legacy priorities kept for old code paths.
export const PRIORITY_LABEL = { critical: 'Critical', high: 'High', medium: 'Medium', low: 'Low' };
export const PRIORITY_COLORS = { critical: '#DE350B', high: '#EB5A46', medium: '#F2D600', low: '#0079BF' };
export const PRIORITY_BG = { critical: '#FFEBE6', high: '#FBEDEA', medium: '#FFF7E6', low: '#E4F0F6' };

// Legacy → keep for reading old records
export const LEGACY_PRIORITY_LABEL = { now: 'Do Now', delegate: 'Delegate', later: 'Do Later', delete: 'Delete' };
export function priorityKey(task) {
  const p = task?.priority_v2 || task?.priority || 'medium';
  if (p === 'now') return 'critical';
  if (p === 'delegate') return 'high';
  if (p === 'later') return 'medium';
  if (p === 'delete') return 'low';
  return p;
}

// Enterprise task statuses (v6)
export const TASK_STATUS_LABEL = {
  new: 'New', pending: 'Pending', in_progress: 'In Progress', review: 'Review',
  testing: 'Testing', completed: 'Completed', rejected: 'Rejected', cancelled: 'Cancelled',
};
export const TASK_STATUS_COLORS = {
  new: '#5E6C84', pending: '#F2D600', in_progress: '#0079BF', review: '#89609E',
  testing: '#00AECC', completed: '#61BD4F', rejected: '#DE350B', cancelled: '#8993A4',
};

// Enterprise project statuses
export const PROJECT_STATUS_LABEL = {
  planning: 'Planning', active: 'Active', on_hold: 'On Hold', completed: 'Completed', cancelled: 'Cancelled',
};
export const PROJECT_STATUS_COLORS = {
  planning: '#89609E', active: '#61BD4F', on_hold: '#F2D600', completed: '#0079BF', cancelled: '#8993A4',
};

// Label swatches for cards (Trello-style)
export const CARD_LABEL_COLORS = [
  { name: 'none', value: null },
  { name: 'red', value: '#EB5A46' },
  { name: 'orange', value: '#FF9F1A' },
  { name: 'yellow', value: '#F2D600' },
  { name: 'green', value: '#61BD4F' },
  { name: 'blue', value: '#0079BF' },
  { name: 'purple', value: '#C377E0' },
  { name: 'pink', value: '#FF78CB' },
];

export const BOARD_BACKGROUNDS = [
  { type: 'gradient', name: 'Blue Ocean', url: null, preview: 'linear-gradient(135deg, #0079BF, #026AA7, #044472)' },
  { type: 'gradient', name: 'Sunset', url: null, preview: 'linear-gradient(135deg, #FF512F, #F09819)' },
  { type: 'gradient', name: 'Forest', url: null, preview: 'linear-gradient(135deg, #134E5E, #71B280)' },
  { type: 'gradient', name: 'Purple Haze', url: null, preview: 'linear-gradient(135deg, #667eea, #764ba2)' },
  { type: 'gradient', name: 'Slate', url: null, preview: 'linear-gradient(135deg, #232526, #414345)' },
  { type: 'image', name: 'Mountains', url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600&q=80', preview: 'url(https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&q=60) center/cover' },
  { type: 'image', name: 'Aurora', url: 'https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?w=1600&q=80', preview: 'url(https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?w=400&q=60) center/cover' },
  { type: 'image', name: 'Ocean', url: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1600&q=80', preview: 'url(https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&q=60) center/cover' },
  { type: 'image', name: 'Desert', url: 'https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=1600&q=80', preview: 'url(https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=400&q=60) center/cover' },
  { type: 'image', name: 'Aurora Sky', url: 'https://images.unsplash.com/photo-1495107334309-fcf20504a5ab?w=1600&q=80', preview: 'url(https://images.unsplash.com/photo-1495107334309-fcf20504a5ab?w=400&q=60) center/cover' },
];

export const backgroundStyle = (project) => {
  if (project?.background_type === 'image' && project.background_url) {
    return { backgroundImage: `url(${project.background_url})` };
  }
  const gradient = BOARD_BACKGROUNDS.find((b) => b.type === 'gradient' && b.name === project?.background_url);
  if (gradient) return { background: gradient.preview };
  return {};
};

export function dueChipClass(task) {
  if (task.completed) return 'tm-due-pill tm-due-done';
  if (!task.due_date) return null;
  const d = new Date(task.due_date); d.setHours(23, 59, 59, 999);
  const now = Date.now();
  const diff = d.getTime() - now;
  if (diff < 0) return 'tm-due-pill tm-due-overdue';
  if (diff < 86400000 * 2) return 'tm-due-pill tm-due-soon';
  return 'tm-due-pill tm-due-ontime';
}

export function fmtDate(d) {
  if (!d) return '';
  const dt = new Date(d);
  return dt.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function initials(u) {
  return ((u?.full_name || u?.email || '?').split(' ').map((s) => s[0]).join('').slice(0, 2)).toUpperCase();
}
